var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 143 143",
    style: {
      enableBackground: "new 0 0 143 143"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5CA3D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.5,79.4c0.6-0.5,0.8-1.2,0.6-1.9c-0.2-0.7-0.9-1.2-1.6-1.2H64.4c-0.7,0-1.4,0.5-1.6,1.2 c-0.2,0.7,0,1.5,0.6,1.9l6.9,5.4V89L64,92c-0.9,0.4-1.2,1.4-0.8,2.3c0.3,0.6,0.9,1,1.5,1c0.3,0,0.5-0.1,0.8-0.2l6.4-3.1 l6.5,2.9c0.9,0.4,1.9,0,2.3-0.9c0.4-0.9,0-1.9-0.9-2.3L73.6,89v-4.2L80.5,79.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.1,72.3c0.7,0,1.4-0.5,1.7-1.3c0.3-0.9-0.3-1.9-1.2-2.1L59.9,67c-0.9-0.3-1.9,0.3-2.1,1.2 c-0.3,0.9,0.3,1.9,1.2,2.1l6.6,1.9C65.7,72.2,65.9,72.3,66.1,72.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84,67l-7,2c-0.9,0.3-1.4,1.2-1.2,2.1c0.2,0.8,0.9,1.3,1.7,1.3c0.2,0,0.3,0,0.5-0.1l7-2 c0.9-0.3,1.4-1.2,1.2-2.1C85.9,67.3,84.9,66.7,84,67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.5,51.6c-13.3,0-21.6,7.1-21.6,18.4c0,7.1,3.4,13.7,9.1,17.9v6.3c0,4.2,3.4,7.6,7.6,7.6h10.5 c4.2,0,7.6-3.4,7.6-7.6l0.1-6.3C90.6,83.8,94,77.2,94,70C94,58.8,85.2,51.6,71.5,51.6z M82.2,85.6c-0.5,0.3-0.8,0.9-0.8,1.5 l-0.1,7.2c0,2.3-1.9,4.2-4.2,4.2H66.6c-2.3,0-4.2-1.9-4.2-4.2v-7c0.1-0.7-0.2-1.3-0.8-1.7c-5.2-3.5-8.4-9.3-8.4-15.5 c0-9.4,6.8-15,18.2-15c9.2,0,19,3.9,19,15C90.5,76.3,87.4,82.1,82.2,85.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.6,46l4-4c0.4-0.4,0.6-0.9,0.5-1.5c-0.1-0.5-0.4-1-0.9-1.3C103.5,39,87,30,71.9,39.1 c-15-9-31.6-0.1-32.3,0.3c-0.5,0.3-0.8,0.7-0.9,1.3c-0.1,0.5,0.1,1.1,0.5,1.5l4,4c-16.5,9.1-14.9,22.3-14.8,22.9 c0.1,0.9,0.8,1.5,1.7,1.5h6.4c-1.1,4.4-2.5,14.4,2.8,24.5c5.4,10.4,16.2,17.8,32.2,22.1c0.1,0,0.3,0.1,0.4,0.1 c0.1,0,0.3,0,0.4-0.1c16-4.3,26.8-11.7,32.2-22.1c5.3-10.1,3.9-20.1,2.8-24.5h6.4c0.9,0,1.6-0.6,1.7-1.5 C115.5,68.3,117.1,55.1,100.6,46z M105.1,66.9c-0.6,0-1.1,0.3-1.4,0.7c-0.3,0.5-0.4,1-0.2,1.6c0,0.1,4.3,12.1-2,24 c-4.9,9.4-14.9,16.2-29.6,20.2c-14.7-4-24.7-10.8-29.6-20.2c-6.2-11.9-2-23.9-1.9-24.1c0.2-0.5,0.1-1.1-0.2-1.6 c-0.3-0.5-0.8-0.7-1.4-0.7h-7c0.2-3.5,1.9-12.5,15.1-18.9c0.5-0.2,0.9-0.7,0.9-1.3c0.1-0.5-0.1-1.1-0.5-1.5l-3.9-3.9 c4.8-2,16.9-5.8,27.5,1.2c0.6,0.4,1.3,0.4,1.9,0c10.6-6.9,22.7-3.2,27.5-1.2l-3.9,3.9c-0.4,0.4-0.6,1-0.5,1.5 c0.1,0.5,0.4,1,0.9,1.3c13.2,6.4,14.9,15.4,15.1,18.9H105.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.6,72.7c0,2.4-1.6,4.3-3.6,4.3c2,0,3.6,1.9,3.6,4.3c0-2.4,1.6-4.3,3.6-4.3 C116.2,77,114.6,75.1,114.6,72.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.1,26c0,2.4-1.6,4.3-3.6,4.3c2,0,3.6,1.9,3.6,4.3c0-2.4,1.6-4.3,3.6-4.3C71.7,30.3,70.1,28.4,70.1,26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.6,106.3c0,2.4-1.6,4.3-3.6,4.3c2,0,3.6,1.9,3.6,4.3c0-2.4,1.6-4.3,3.6-4.3 C99.2,110.6,97.6,108.7,97.6,106.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.1,72c0.2,2.4-1.3,4.4-3.3,4.5c2-0.1,3.7,1.7,3.9,4c-0.2-2.4,1.3-4.4,3.3-4.5C30,76.2,28.2,74.4,28.1,72 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.4,47.3c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.4-0.6-1.4-1.3s0.6-1.3,1.4-1.3C112.8,46,113.4,46.6,113.4,47.3 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.6,30.3c0,0.7-0.6,1.4-1.3,1.4c-0.7,0-1.4-0.6-1.4-1.4c0-0.7,0.6-1.3,1.4-1.3 C82,28.9,82.6,29.5,82.6,30.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 37.5,
    cy: 100.5,
    r: 1.4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeo);
export default __webpack_public_path__ + "static/media/Leo.7486fd39da6dbc871741a85a7f2b9c64.svg";
export { ForwardRef as ReactComponent };